import { Type, isKey, isContainer } from '../helpers.js'

export default function GeneralCommands(context) {
    let { evaluate } = context;

    function List(...args) { return args; }

    function _Object(keyVal, ...rest) {
        let type = Type(keyVal);
        let next = () => (rest.length > 0) ? _Object(...rest) : {};
        if (type === 'object') {
            return Object.assign({}, keyVal, next());
        }
        let obj    = {};
        let kv     = (type === 'array') ? keyVal : [keyVal];
        let [k, v] = [evaluate(kv[0]), evaluate(kv[1])];
        if (isKey(k)) { obj[k] = v; }
        return Object.assign(obj, next());
    }

    function Get(obj, ...keys) {
        function _get(obj, keys) {
            let [key, ...rest] = keys;
            return (keys.length < 1) ? obj :
                    isContainer(obj) ? _get(obj[key], rest)
                                     : null;
        }
        [obj, keys] = isKey(obj) ? [context, [obj, ...keys]] : [obj, keys];
        return _get(obj, keys);
    }

    function Set(obj, ...path) {
        function _childObj(obj, keys) {
            let [k, k2] = keys;
            let child = Get(obj, k);
            let sub = (Type(k2) === 'number') ? [...Array(k2)].map(x => null) : {};
            return (keys.length < 2 || isContainer(child)) ? child : (obj[k] = sub);
        }
        function _set(obj, keys, val) {
            let [key, ...rest] = keys;
            return (keys.length < 1) ? val :
                   !isContainer(obj) ? val :
                   (keys.length < 2) ? (obj[key] = val)
                                     : _set(_childObj(obj, keys), rest, val);
        }
        [obj, path] = isKey(obj) ? [context, [obj, ...path]] : [obj, path];
        let val  = path.slice(-1)[0];
        let keys = path.slice(0, -1);
        return _set(obj, keys, val);
    }

    function Exists(obj, ...keys) {
        function _exists(obj, keys) {
            let [key, ...rest] = keys;
            return (keys.length < 1) ? false :
                   !isContainer(obj) ? false :
                   (keys.length < 2) ? ({}).hasOwnProperty.call(obj, key)
                                     : _exists(Get(obj, key), rest);
        }
        [obj, keys] = isKey(obj) ? [context, [obj, ...keys]] : [obj, keys];
        return _exists(obj, keys);
    }

    function NewGuid() {
        // Generates an RFC4122 v4 UUID - https://stackoverflow.com/a/2117523/1270393
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    return { Type, List, _Object, Get, Set, Exists, NewGuid };
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/command-action-handler/src/commands/general.js